import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["container", "template"]

    add(event) {
        event.preventDefault()
        
        // Remove empty message if exists
        const emptyMessage = this.containerTarget.querySelector('[data-dynamic-dates-empty-message]')
        if (emptyMessage) {
            emptyMessage.remove()
        }
        
        const content = this.templateTarget.innerHTML
        this.containerTarget.insertAdjacentHTML('beforeend', content)
    }

    remove(event) {
        event.preventDefault()
        const item = event.target.closest('[data-dynamic-dates-item]')
        if (item) {
            item.remove()
        }
        
        // Show empty message if no items left
        const items = this.containerTarget.querySelectorAll('[data-dynamic-dates-item]')
        if (items.length === 0) {
            this.containerTarget.insertAdjacentHTML('beforeend', 
                '<p class="text-center text-slate-400 py-6 text-sm italic" data-dynamic-dates-empty-message>No specific dates added. The start date above will be used.</p>'
            )
        }
    }
}
